// extracted by mini-css-extract-plugin
module.exports = {"domainListing":"FavoritePremiumDomains_domainListing__3JHDq","error":"FavoritePremiumDomains_error__3_9fh","noEntries":"FavoritePremiumDomains_noEntries__3D2zq"};